<app-breadcrumb></app-breadcrumb>
<div class="container">
     <div class="main-container-chart" *ngIf="chartResponseData$ | async as chartResponseData">
          <label class="ch-title">Flight Time by Month</label>
          <div class="container-paging">
               <button class="chevron-btn" (click)="onDecrementYear()" [disabled]="btnDisabledDecrement">
                    <span class="pi pi-angle-left"
                         [style]="{'color': btnDisabledDecrement ? 'var(--text-tertairy)' : 'var(--text-primary)'}"></span>
               </button>
               <div class="ch-year">{{activeYear}}</div>
               <button class="chevron-btn" (click)="onIncrementYear()" [disabled]="btnDisabledIncrement">
                    <span class="pi pi-angle-right"
                         [style]="{'color': btnDisabledIncrement ? 'var(--text-tertairy)' : 'var(--text-primary)'}"></span>
               </button>
          </div>
          <p-tabMenu class="tab-menu" [model]="tabItems" [activeItem]="activeItem"
               (activeItemChange)="onActiveItemChange($event)" />
          <div class="chart">
               <p-chart type="line" [data]="chartData" [options]="toggleThemeOptions()" width="100%" height="350px" />
               <!-- } -->
               
          </div>
          <div class="ch-footer">Tap on a bar/point to see the flight time for that month.</div>
          <div class="card">
               <div class="column">
                    <div class="row">
                         <div>{{activeYear}} Total</div>
                         <div>{{periodTotal | number: '1.1-2'}} hrs</div>
                    </div>
                    <div class="row">
                         <div>Highest Month - {{highestMonthLabel}}</div>
                         <div>{{highestMonth | number: '1.1-2'}} hrs</div>
                    </div>
                    <div class="row">
                         <div>Average for {{activeYear}}</div>
                         <div>{{periodAverage | number: '1.1-2'}} hrs</div>
                    </div>

               </div>
          </div>
     </div>
</div>